var React = require('react');

function Ced (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","strokeMiterlimit":"16","strokeWidth":"50","d":"M225 425a200 200 0 110-400","key":0}),React.createElement("path",{"fill":"none","strokeWidth":"50","d":"M375 225c0 74.3-54 136-125 148V77a150 150 0 01125 148zM200.5 170v1h-1v-1zM200 279v1h-1v-1z","key":1})]);
}

Ced.defaultProps = {"viewBox":"0 0 400 450","stroke":"currentColor"};

module.exports = Ced;

Ced.default = Ced;
